export function consumeLoginReturnTo(): string {
  const returnTo = sessionStorage.getItem("returnTo")
  sessionStorage.removeItem("returnTo")
  if (
    !returnTo ||
    !returnTo.startsWith("/") ||
    returnTo.startsWith("//") ||
    /[\s\\]/u.test(returnTo) ||
    Array.from(returnTo).some((character) => character.charCodeAt(0) <= 0x1f || character.charCodeAt(0) === 0x7f)
  ) {
    return "/dashboard"
  }

  try {
    const windowOrigin = typeof window === "undefined" ? undefined : window.location?.origin
    const baseOrigin = windowOrigin && windowOrigin !== "null" ? windowOrigin : "https://app.invalid"
    const url = new URL(returnTo, baseOrigin)
    if (url.origin === baseOrigin) {
      return url.pathname + url.search + url.hash
    }
  } catch {
    return "/dashboard"
  }

  return "/dashboard"
}
